let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9VCJ3")).then(() => parcelRequire('65haw'));